/* ═══════════════════════════════════════════════════════════════
   Timesheets rebuild — date helpers (Tranche 2).

   Week math is NEVER reimplemented here — `mondayOf` / `addDays` /
   `enumerateWorkdays` come straight from timeService (the ONE UTC
   week-math brain shared with Forecasting). This file only adds thin
   ISO-string ⇄ display formatting on top, so the rest of the page
   never touches a JS `Date` for arithmetic — only for final render.
   ═══════════════════════════════════════════════════════════════ */

import { mondayOf, addDays as addDaysISO } from '../../services/timeService';

export const DAY_NAMES = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

/** Today's date as YYYY-MM-DD in the user's local wall-clock day
 *  (not shifted to UTC) — "Today" should mean today where the user
 *  is sitting, not in Greenwich. */
export function todayISO(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Monday-of-week for "today". */
export function mondayOfTodayISO(): string {
  return mondayOf(todayISO());
}

/** The 7 ISO dates (Mon..Sun) for a Monday-anchored week. */
export function weekDatesFrom(weekStartISO: string): string[] {
  return Array.from({ length: 7 }, (_, i) => addDaysISO(weekStartISO, i));
}

/** "Aug 19" — UTC-anchored parse so no local-timezone day-shift ever
 *  occurs (an ISO date string carries no time-of-day to shift). */
export function formatShort(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });
}

/** "8/19" — compact month/day for column sub-headers. */
export function formatMD(iso: string): string {
  const [, m, d] = iso.split('-').map(Number);
  return `${m}/${d}`;
}

/** Four-digit year of an ISO date string. */
export function yearOf(iso: string): number {
  return Number(iso.split('-')[0]);
}

export { mondayOf, addDaysISO as addDays };
